import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './body.scss';
import './animations.scss';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);